






import { Component, Prop, Vue } from "vue-property-decorator";
import BSwitch from "@/components/app/switchs/b-switch.vue";

@Component({ components: { BSwitch } })
export default class StandartSwitch extends Vue {
  @Prop({ type: Boolean, default: false }) checked!: boolean;
  @Prop({ type: String, default: null }) name!: string;
}
